export const findTrainingLicenseIdAndKey = (site, program) => {
  const license = site?.netSuiteAssets.find(asset =>
    asset?.product?.programCodes?.some(code => code === program),
  )
  return {
    licenseId: license?.id,
    dataKey: license ? `${site.id}.${license.id}.${program}` : null,
  }
}
